"use client"

import type { ComponentPropsWithoutRef, ReactNode } from "react"

import React, { useEffect, useRef } from "react"

import { twMerge } from "#lib/twMergeConfig"

export function Dialog({
  open,
  modal,
  onClose,
  className,
  children,
  dialogRef,
  ...restProps
}: { open?: boolean; modal: boolean; dialogRef?: React.RefObject<HTMLDialogElement>; onClose?: (closeReason: string) => void; children: ReactNode } & Omit<
  ComponentPropsWithoutRef<"dialog">,
  "onClose"
>) {
  const fallbackDialogRef = useRef<HTMLDialogElement>(null)

  const dialog = dialogRef ?? fallbackDialogRef

  useEffect(() => {
    if (!dialog.current?.open && open) {
      if (modal) {
        dialog.current?.showModal()
      } else dialog.current?.show()
    } else if (dialog.current?.open && !open) {
      dialog.current.close("normal")
    }
  }, [open])

  /*
   * Wenn aufs backdrop etc geklickt wird, dismiss durchführen
   */
  function handleLightDismiss(e: any) {
    if (e.target.nodeName === "DIALOG") {
      dialog.current?.close("light-dismiss")
    }
  }

  return (
    <dialog
      {...restProps}
      style={{ ...restProps.style, padding: 0, margin: 0, ...(modal ? { inset: 0, position: "fixed" } : {}) }}
      ref={dialog}
      className={twMerge(
        className,
        "pointer-events-none z-[500000] block opacity-0 outline-none transition-all duration-300 open:pointer-events-auto open:opacity-100 focus-visible:outline-none",
      )}
      onClick={e => handleLightDismiss(e)}
      onClose={(e: any) => {
        if (onClose) onClose(e.target.returnValue)
      }}>
      {children}
    </dialog>
  )
}
